var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.827 1a4.827 4.827 0 100 9.653 4.827 4.827 0 000-9.653zM0 5.827a5.827 5.827 0 1111.653 0A5.827 5.827 0 010 5.827z",
    fill: "#36354C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.146 4.267a.5.5 0 010 .707L5.363 7.757a.26.26 0 01-.367 0L3.513 6.274a.5.5 0 01.707-.707l.96.96 2.26-2.26a.5.5 0 01.706 0z",
    fill: "#36354C"
  })));
}
export default SvgCircleTick;